'use es6';

export const crmScpDealsAccess = 'crm-scp-deals-access';